import { AxiosError, type CreateAxiosDefaults, create } from 'axios';

import { type ApiConfig, Api as TypedApiClient } from '~/__generated__/api';
import { login } from '~/common/hooks/useAuthentication';

const axiosOptions: CreateAxiosDefaults = {
  baseURL: `${globalThis.globalConfig?.api.endpoint_uri}/`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => {
    return Object.keys(params)
      .map((key) => {
        if (Array.isArray(params[key])) {
          return params[key]
            .map(
              (value) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
            )
            .join('&');
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      })
      .join('&');
  },
};

const apiClient = create(axiosOptions);
apiClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error: Error) {
    if (
      error instanceof AxiosError &&
      error.status === 401 &&
      !error.request?.responseURL?.includes('/Account/Userinfo')
    ) {
      login();
    }
    return Promise.reject(error);
  },
);

/**
 * Typed Api Client
 * @description This client has the same functionality as the `apiClient` defined above, but has an extra layer of methods to give type-safe access to our BOLTXX endpoints.
 * Read the README.md in this file's directory for more information
 * @example
 * // The first parameter is the payload to send as the body to the endpoint
 * // You can pass a second paramter which will be of type `AxiosRequestConfig` if you want to edit the behavior of the Axios client for that request 
 * const { data } = await typedApiClient.v1.propertyInformationGetQuestionAnswersDataAsync({
      context,
      obfuscatedLoanIdentifier,
    });
 */
export const typedApiClient = new TypedApiClient(axiosOptions as ApiConfig);
typedApiClient.instance = apiClient;

/**
 * @deprecated Prefer using the `typedApiClient` for more safety when calling BOLTXX endpoints.
 * Read the README.md in this file's directory for more information
 */
export default apiClient;
